export interface IUpdatePoaRequest {
    region_id: string;
    shipping_class_id: string;
    status: number | boolean;
    index: number;
}
